export default function isValidDocumentIdFormat(id: string | null) {
  if (id == null) {
    return false;
  }
  return /^[a-zA-Z0-9-]{1,36}$/.test(id) && !id.startsWith('-') && !id.endsWith('-');
}
